/** @format */

import {AccountsKpiName} from 'graphql/generated/types';

export const MAX_VISIBLE_CARDS = 8;
export const MAX_VISIBLE_SENSORS = 4;

export const KPI_DISPLAY_NAMES: Record<AccountsKpiName, string> = {
  CPL: 'CPL',
  CPC: 'CPC',
  CPM: 'CPM',
  AVG_VIDEO_COMPLETE_COST: 'Ср. стоимость просмотра',
  DRR: 'DRR',
  ER: 'ER',
  ROMI: 'ROMI',
  VTR: 'VTR',
  CLICKS: 'Клики',
  IMPRESSIONS: 'Показы',
  REVENUE: 'Доход',
  REACH: 'Охват',
};

export const LOWER_IS_BETTER_KPI: AccountsKpiName[] = [
  'CPL',
  'CPC',
  'CPM',
  'DRR',
  'AVG_VIDEO_COMPLETE_COST',
];

export const GRID_COLUMNS_BY_COUNT: Record<number, number> = {
  1: 12,
  2: 6,
  3: 4,
  5: 4,
  7: 4,
};

